@import (reference) '../../../../../constants/spacing.module.less';
@import (reference) '../label-details/label-details.module.less';

@labelDetailsInnerRow: .label-info();
@labelDetailsServiceName: .service-name();

.inner-row {
  @labelDetailsInnerRow();
}

.details-section {
  flex: 1;
  gap: @space-4;
}

.fulfillment-service-name {
  flex: 1;

  @labelDetailsServiceName();
  text-decoration: line-through currentcolor;
}

.delegation-and-status-section {
  display: flex;
  flex-flow: row nowrap;
  gap: @space-12;
  color: var(--light--text-color--1);
}

.info-block {
  display: flex;
  gap: @space-4;
}

.status-value {
  display: inline-flex;
  gap: @space-4;
}

.status-icon {
  display: flex;
  align-items: center;
}
